import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import ProductCardStyles from '@stories/Components/Cards/ProductCard/ProductCard.styles';
import FiltersFormStyles from '@stories/Components/Misc/FiltersForm/FiltersForm.styles';
import { FiltersFormColumns } from '@stories/Components/Misc/FiltersFormContainer/FiltersFormContainer.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }
`;
const FormWrapper = styled(FiltersFormStyles.Container) `
  gap: ${fluid(24, 36)};
`;
const ResultContainer = styled.div `
  scroll-margin: calc(var(--headerHeight, 0px) + ${fluid(16, 32)}) 0 0;
`;
const ProductCards = styled.div `
  ${FiltersFormColumns};

  display: flex;
  gap: ${fluid(24, 26)};
  flex-direction: column;
  margin-top: ${fluid(32, 64)};
  scroll-margin: calc(var(--headerHeight, 0px) + ${fluid(16, 32)}) 0 0;

  @media ${from(Device.TabletLarge)} {
    --widthModifier: ${fluid(64, 147)};

    ${ProductCardStyles.Container} {
      width: calc(100% + var(--widthModifier));
      margin-left: calc(var(--widthModifier) * -0.5);
    }
  }
`;
const BuyToLetRentalIncomeCalculatorStyles = {
    Container,
    FormWrapper,
    ProductCards,
    ResultContainer,
};
export default BuyToLetRentalIncomeCalculatorStyles;
